import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Toaster } from "react-hot-toast";

import App from "./App.jsx";
import store from "./redux/store";
import "./index.css";
import { initializeSentry } from "./sentry.js";

initializeSentry();

ReactDOM.render(
  <Provider store={store}>
    <App />
    <Toaster />
  </Provider>,
  document.getElementById("root"),
);

// ReactDOM.createRoot(document.getElementById("root")).render(
//   <Provider store={store}>
//     <App />,
//     <Toaster />
//     {/* <ReduxToastr timeOut={1500} transitionIn="fadeIn" transitionOut="fadeOut" /> */}
//   </Provider>,
// );
